export default defineNuxtRouteMiddleware(() => {
  if (!import.meta.server) return

  useIDs().init()
})
